import { render, staticRenderFns } from "./ActionPrioridadAsignacion.vue?vue&type=template&id=f9041b72&lang=pug"
import script from "./ActionPrioridadAsignacion.vue?vue&type=script&lang=js"
export * from "./ActionPrioridadAsignacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports